export const formatRegistrationResendWait = (seconds, { limitReached = false } = {}) => {
  if (limitReached) {
    return `Resend limit reached. Try again in ${Math.floor(seconds / 60)}m ${seconds % 60}s.`
  }

  return `Try again in ${seconds}s.`
}

export const createRegistrationResendHandlers = ({ button, countdown, readyStatus, limitReached = false }) => ({
  onTick: (seconds) => {
    button.disabled = seconds > 0
    if (countdown) countdown.textContent = formatRegistrationResendWait(seconds, { limitReached })
  },
  onReady: () => {
    button.disabled = false
    if (countdown) countdown.textContent = ''
    if (readyStatus) readyStatus.textContent = 'Resend code is available.'
  }
})

export default class RegistrationResendCountdown {
  constructor ({
    availableAt,
    now = () => Date.now(),
    schedule = (callback, delay) => window.setTimeout(callback, delay),
    cancel = (id) => window.clearTimeout(id),
    onTick,
    onReady
  }) {
    this.availableAt = availableAt
    this.now = now
    this.schedule = schedule
    this.cancel = cancel
    this.onTick = onTick
    this.onReady = onReady
  }

  start () {
    this.stop()
    this.tick()
  }

  stop () {
    if (this.timeoutId) this.cancel(this.timeoutId)
    this.timeoutId = null
  }

  tick () {
    const milliseconds = Math.max(0, this.availableAt - this.now())
    const seconds = Math.ceil(milliseconds / 1000)
    this.onTick(seconds)

    if (milliseconds === 0) {
      this.onReady()
      return
    }

    this.timeoutId = this.schedule(() => this.tick(), Math.min(1000, milliseconds))
  }
}
